import { MutationTree } from 'vuex';
import {SystemActionsState} from "@/store/user_management/system_actions/types";

export const mutations: MutationTree<SystemActionsState> = {
  setSystemActions: (state, payload) => {
    state.systemActions = payload;
  },
  setSystemUsersAction(state, data) {
    state.systemUsersAction = data;
  },
}
